import React, { createContext, useContext, useState, useEffect } from 'react';

const ChimeraContext = createContext(null);

export const ChimeraProvider = ({ chimeraProvider, children }) => {
  const [config, setConfig] = useState(chimeraProvider?.config || null);
  const [user, setUser] = useState(chimeraProvider?.user || null);
  const [auth, setAuth] = useState(chimeraProvider?.auth || null);

  useEffect(() => {
    if (!chimeraProvider || !chimeraProvider.isConnected) {
      return;
    }

    const configSub = chimeraProvider.configObserver.subscribe((nextConfig) => {
      setConfig(nextConfig);
    });

    const userSub = chimeraProvider.userObserver.subscribe((nextUser) => {
      setUser(nextUser);
    });

    const authSub = chimeraProvider.authSubject.subscribe((nextAuth) => {
      setAuth(nextAuth);
    });

    return () => {
      configSub.unsubscribe();
      userSub.unsubscribe();
      authSub.unsubscribe();
    };
  }, [chimeraProvider]);

  const value = {
    isConnected: chimeraProvider?.isConnected || false,
    config,
    user,
    auth,
    apps: config?.apps || [],
  };
  return (
    <ChimeraContext.Provider value={value}>
      {children}
    </ChimeraContext.Provider>
  );
};

// Один простой hook для всего
export const useChimera = () => {
  const context = useContext(ChimeraContext);
  if (!context) {
    // Если не в ChimeraProvider - возвращаем дефолтные значения
    return {
      isConnected: false,
      config: null,
      user: null,
      auth: null,
      apps: [],
    };
  }
  return context;
};

